// extracted by mini-css-extract-plugin
export default {"footerPage":"Fotter_footerPage__E-Gi5","logo":"Fotter_logo__WXgDv","poweredBy":"Fotter_poweredBy__hn08C"};